import {
  DEFAULT_CATALOG,
  FREE_SKU,
  HISTORY_VIEW_UNLIMITED_GRANT,
  LIMIT_HISTORY_VIEW_DAYS,
  LIMIT_LEVELING_RULES,
  TIER_PRO_SKU,
  TITAN_S_SKU,
} from "@colossus/contracts";

export interface Tier {
  readonly sku: string;
  readonly days: number | null;
}

const retentionOf = (sku: string): number | null => {
  const seed = DEFAULT_CATALOG.find((entry) => entry.sku === sku);
  if (seed === undefined) throw new Error(`${sku} is not in the catalogue`);
  if (seed.grants.some((grant) => grant.key === HISTORY_VIEW_UNLIMITED_GRANT && grant.value)) {
    return null;
  }
  const days = seed.grants.find((grant) => grant.key === LIMIT_HISTORY_VIEW_DAYS)?.value;
  if (typeof days !== "number") throw new Error(`${sku} carries no retention window`);
  return days;
};

export const TIERS: readonly Tier[] = [FREE_SKU, TIER_PRO_SKU, TITAN_S_SKU].map((sku) => ({
  sku,
  days: retentionOf(sku),
}));

export const rulesOf = (sku: string): number => {
  const seed = DEFAULT_CATALOG.find((entry) => entry.sku === sku);
  const rules = seed?.grants.find((grant) => grant.key === LIMIT_LEVELING_RULES)?.value;
  if (typeof rules !== "number") throw new Error(`${sku} carries no rule ceiling`);
  return rules;
};

export const daysOf = (sku: string): number => {
  const days = TIERS.find((tier) => tier.sku === sku)?.days;
  if (days === undefined || days === null) throw new Error(`${sku} keeps no window`);
  return days;
};
